import { render } from "./ManagerDashboardOps.vue?vue&type=template&id=0d65e4f6&scoped=true"
import script from "./ManagerDashboardOps.vue?vue&type=script&lang=js"
export * from "./ManagerDashboardOps.vue?vue&type=script&lang=js"

import "./ManagerDashboardOps.vue?vue&type=style&index=0&id=0d65e4f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d65e4f6"]])

export default __exports__